import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';
import React from 'react';

const Footer: React.FC = () => {
  const intl = useIntl();

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={intl.formatMessage({
        id: '布局.页脚.版权',
        defaultMessage: '2026 dodojob 运营管理后台',
      })}
      links={[]}
    />
  );
};

export default Footer;
